// extracted by mini-css-extract-plugin
export default {"card":"Q2bGxpxg6otk6cTe6UKp","invoiceNumber":"GhN_iNaGv1Payx6AigOT","address":"YPJhf0ABhoI2YrqaT2Eo","payButton":"t7KYsTVyolEpWM3Kf1pv"};